/* eslint-disable */

import React, { forwardRef, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CustomerConfirmationDialog({isOpen, customerData, contractConfirmationHandler}) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('change-agreement');

  const handleChange = (event) => {
    setValue(event.target.value);
  };


  useEffect(() => {
    if(isOpen){
        handleClickOpen();
    }else{
        handleClose();
    }
  }, [isOpen])

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmitHandler = (item) => {
    if(item === 'continue'){
        handleClose();
        contractConfirmationHandler(value);
    } else {
    contractConfirmationHandler('cancel');
    handleClose();
    }
  }

  return (
    <React.Fragment>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Slide in alert dialog
      </Button> */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Contract Found</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {`This Customer has already Contract ${customerData?.full_name} (${customerData?.username})`}
          </DialogContentText>
          <FormControl>
      <FormLabel id="demo-row-radio-buttons-group-label" sx={{fontWeight: '600', color:'#404040'}}>Select Action</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={value}
        onChange={handleChange}
      >
        <FormControlLabel value="add-ons" disabled control={<Radio />} label="Add Ons" />
        <FormControlLabel value="change-agreement" control={<Radio />} label="Change Agreement" />
        {/* <FormControlLabel
          value="disabled"
          disabled
          control={<Radio />}
          label="other"
        /> */}
      </RadioGroup>
    </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onSubmitHandler('cancel')}>Cancel</Button>
          <Button onClick={() => onSubmitHandler('continue')}>Continue</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
